import React from 'react';
import { Investment } from '@/types/investment';

interface ContentProps {
  investment: Investment;
}

const Content: React.FC<ContentProps> = ({ investment }) => {
  return (
    <div className="space-y-4">
      <h2 className="text-2xl font-semibold text-foreground">Content</h2>
      <p className="text-base text-muted-foreground">{investment.content}</p>
    </div>
  );
};

export default Content;
